import { render, staticRenderFns } from "./tableModule.vue?vue&type=template&id=35677336&"
import script from "./tableModule.vue?vue&type=script&lang=js&"
export * from "./tableModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports